import React from "react";
import { Button, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toDateTimeFR } from "../../../utils/datesHeures";
import { BiMessageDetail } from "react-icons/bi";
import ComponentThemesContribution from "./ComponentThemesContribution";

const ComponentContribution = (props) => {
  const { t } = useTranslation();
  const { contributionObject } = props;

  const genereUrlEspace = (type) => {
    if (type === "detail") {
      return (
        process.env.REACT_APP_URL_COLIDEE +
        "o" +
        contributionObject.id_entreprise +
        "p" +
        contributionObject.id_plateforme +
        "/participation-" +
        contributionObject.id_contribution +
        ".htm"
      );
    }

    if (type === "enrichir") {
      return (
        process.env.REACT_APP_URL_COLIDEE +
        "o" +
        contributionObject.id_entreprise +
        "p" +
        contributionObject.id_plateforme +
        "/?enrichir=" +
        contributionObject.id_contribution
      );
    }

    if (type === "participer") {
      return (
        process.env.REACT_APP_URL_COLIDEE +
        "o" +
        contributionObject.id_entreprise +
        "p" +
        contributionObject.id_plateforme +
        "?openParticiper=1"
      );
    }
  };

  return (
    <div className="d-flex flex-column justify-content-between align-items-center  blocContributionUser border m-2">
      <span className="overflowInContent">
        <div>
          <div className="d-flex flex-row p-2">
            <img
              className="avatar rounded-circle me-2"
              src={contributionObject.pictureColideur}
              alt={contributionObject.prenomColideur + " " + contributionObject.nomColideur}
            />
            <div className="flex-grow-1 ">
              <span className="identite d-block">
                {contributionObject.id_UserClient && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      process.env.REACT_APP_URL_COLIDEE +
                      "/profile/" +
                      contributionObject.id_UserClient
                    }
                  >
                    {contributionObject.prenomColideur} {contributionObject.nomColideur}
                  </a>
                )}
                {!contributionObject.id_UserClient && contributionObject.prenomColideur}

                {contributionObject.illustrationSmall !== "" && (
                  <>
                    <Image
                      className="float-end"
                      src={contributionObject.illustrationSmall}
                      style={{ height: "40px", maxWidth: "inherit" }}
                    />
                  </>
                )}
              </span>
              <span className="date">{toDateTimeFR(contributionObject.datePublication)}</span>
            </div>
          </div>

          <div className="flex-grow-1 p-2 pt-0">
            <a href={genereUrlEspace("detail")} target="_blank" rel="noreferrer">
              <div className="contribution">
                <ComponentThemesContribution contribution={contributionObject} />
                {contributionObject.contribution}
                {/* {contributionObject.illustrationSmall !== "" && (
                  <>
                    <br />
                    <Image
                      src={contributionObject.illustrationSmall}
                      style={{ height: "inherit", maxWidth: "inherit" }}
                    />
                  </>
                )} */}
              </div>
            </a>
            {contributionObject.nomPlateforme && (
              <div className="mt-2 nomPlateforme">
                {contributionObject.nomPlateforme}
                {contributionObject.conf_publique === "0" && (
                  <span className="ms-1 ps-1 pe-1 privatePlateforme">Privé</span>
                )}
                <br />
                <span className="fst-italic">
                  <BiMessageDetail size="1.5em" /> {contributionObject.NbrContributions}
                </span>
              </div>
            )}
          </div>
        </div>
      </span>
      <Button
        className="buttonCard w-50"
        href={genereUrlEspace("participer")}
        target="_blank"
        rel="noreferrer"
      >
        {t("public.boutons.je_participe")}
      </Button>
      {/* <div className="d-flex flex-nowrap buttonColidee">
        <a
          href={genereUrlEspace("enrichir")}
          target="_blank"
          rel="noreferrer"
          className="text-center flex-grow-1 border-top   border-end"
        >
          {t("public.componentContribution.enrichir")}
        </a>
        <a
          href={genereUrlEspace("participer")}
          target="_blank"
          rel="noreferrer"
          className="text-center  flex-grow-1 border-top"
        >
          {t("public.componentContribution.participer")}
        </a>
      </div> */}
    </div>
  );
};

export default ComponentContribution;
